import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Slider from '@wix/da-ds/pkg/Slider';
import { Props } from '@wix/da-ds/pkg/Slider/Slider';
import { getSliderConfiguration } from '@wix/da-ds/pkg/Slider/helpers';
import { BREAKPOINTS as breakpoints } from '@wix/da-ds/pkg/Slider/constants';
import { ScreenSizeContext } from '@wix/da-hooks/pkg/useMeasureElement/ScreenSizeContext';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';

// TODO this should really accept cookie type as all sliders share the same cookie currently
export interface MeasuredSliderProps extends Omit<Props, 'children'> {
  children?: React.ReactNode | undefined;
  renderSliderItems: (elementSize: {
    width: number;
    height: number;
  }) => React.ReactElement | React.ReactElement[];
}

const MeasuredSlider: React.FC<MeasuredSliderProps> = ({
  children,
  renderSliderItems,
  ...restProps
}) => {
  const { width: screenWidth } = useContext(ScreenSizeContext);
  const isMobile = useContext(MobileContext);
  const { ref, dimensions } = useMeasureElementCookie(
    MeasuredCookieType.SLIDER,
    {
      cookieDim: 'width',
    }
  );
  const { elementWidth, elementHeight } = getSliderConfiguration({
    breakpoints,
    screenWidth,
    containerWidth: dimensions.width,
    dontScale: isMobile,
  });
  return (
    <div ref={ref}>
      <Slider {...restProps}>
        {renderSliderItems({
          width: elementWidth,
          height: elementHeight,
        })}
      </Slider>
    </div>
  );
};
MeasuredSlider.displayName = 'MeasuredSlider';

export default MeasuredSlider;
